<div class="row justify-content-center mb-4">
    <div class="col-12 text-center mb-3">We will automatically collect Email/Name. Add any additional information to be collected.</div>
    <button
        class="btn btn--paybee btn--black"
        (click)="addAdditionalGuestInfo()"
    >Add Guest Info Option</button>
</div>
<ng-container [formGroup]="formGroupCampaignTypeData">
    <ul class="list-group ui-sortable" formArrayName="guestProfile" cdkDropList (cdkDropListDropped)="dropOption($event)">
        <li class="list-group-item" *ngFor="let option of options.controls;index as i;" cdkDragLockAxis="y" cdkDrag>
            <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
            <div class="preset-option d-flex">
                <div class="preset-option__drag-and-drop d-flex align-items-center justify-content-center">
                    <app-icon-menu></app-icon-menu>
                </div>
                <ng-container [formGroup]="option">
                    <div class="preset-option__content d-flex align-items-center">
                        <div class="preset-option__number">{{i+1}}.</div>
                        <div class="preset-option__container d-flex flex-column">
                            <div class="preset-option__name mb-1">{{option.value.infoName}}</div>
                        </div>
                        <div class="preset-option__actions">
                            <div class="preset-option__action">
                                <app-icon-pen (click)="editAdditionalGuestInfo(option.value, i)"></app-icon-pen>
                            </div>
                            <div class="preset-option__action" (click)="removeOption(i)">
                                <app-icon-trash></app-icon-trash>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </li>
    </ul>
</ng-container>